module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-combobox', {
    ref: "tags",
    attrs: {
      "multiple": "",
      "value": _vm.value,
      "items": _vm.tags,
      "item-text": "name",
      "item-value": "id",
      "label": "Tags",
      "small-chips": "",
      "deletable-chips": "",
      "return-object": ""
    },
    on: {
      "change": function($event) {
        _vm.$emit('change', $event)
      },
      "input": function($event) {
        _vm.$emit('input', $event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "space", 32, $event.key)) { return null; }
        _vm.updateOnSpace('tags')
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a70b891","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inputs/InputAudioTags.vue
// module id = 342
// module chunks = 0